import { motion } from "framer-motion";
import bgImage from "../../assets/images/image4.jpg";
import bgImage1 from "../../assets/images/hero-image-12.jpg"; // Background image 1

export default function ChooseUs() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const headingWords = [
    "We",
    "deliver",
    "more",
    "than",
    "adventure.",
    "We",
    "deliver",
    "momentum.",
  ];

  return (
   <section className="relative overflow-hidden w-full bg-black text-white py-20 sm:py-24 border-t border-neutral-900">
      
        {/* 🔥 3D Animated Background Images */}
      <motion.img
        src={bgImage1}
        alt="Background Layer 1"
        className="absolute inset-0 w-full h-full object-cover z-0 "
        initial={{ scale: 1.2, y: 0 }}
        animate={{ scale: 1.35, y: -60 }}
        transition={{
          duration: 6,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut",
        }}
      />
   {/* DARK OVERLAY — BACKGROUND ONLY */}
      <div className="absolute inset-0 bg-[#0e202b]/45 z-0" />

      {/* Content Wrapper */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        {/* Label */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="text-[10px] sm:text-[11px] tracking-[0.25em] text-neutral-100 uppercase">
            [02]
          </p>
          <p className="text-[10px] sm:text-[11px] tracking-[0.25em] text-neutral-100 uppercase mt-1">
            Why choose us
          </p>
        </motion.div>

        {/* Heading */}
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mt-6 sm:mt-8 text-left text-neutral-300 font-extrabold leading-[1.05] max-w-5xl text-[clamp(2.4rem,5vw,5.3rem)]"
        >
          {headingWords.map((word, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="inline-block mr-2"
            >
              {word}
            </motion.span>
          ))}
        </motion.h2>

        {/* Description */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mt-4 sm:mt-6 max-w-3xl text-[15px] sm:text-[17px] leading-relaxed text-neutral-200"
        >
         BroadBoy Adventures is built on the spirit of exploration. We document Himalayan expeditions, mountaineering feats, and cinematic mountain journeys bringing the raw beauty and grit of mountains to you.
        </motion.p>

        {/* Grid */}
        <div className="mt-14 sm:mt-16 grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 gap-4 sm:gap-5">
          {/* LEFT: Bar Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ scale: 0.985 }}
            transition={{ duration: 0.4 }}
            className="md:row-span-2 bg-[#162230] border border-[#2b2b2b] rounded-xl p-5 sm:p-6 flex flex-col justify-between overflow-hidden group"
          >
            <div className="flex justify-end">
              <div className="w-8 h-8 rounded-md bg-white flex items-center justify-center text-black font-semibold transform group-hover:-translate-y-[2px] group-hover:translate-x-[2px] transition-all duration-300">
                ↗
              </div>
            </div>

            <div className="relative flex items-end gap-[3px] h-32 sm:h-40 mt-6">
              {Array.from({ length: 20 }).map((_, i) => (
                <motion.div
                  key={i}
                  className="flex-1 bg-[#4b5358] rounded-t-[2px]"
                  initial={{ height: 0 }}
                  whileInView={{
                    height: `${Math.random() * 70 + 25}%`,
                  }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 1,
                    delay: i * 0.02,
                  }}
                />
              ))}
            </div>

            <div className="flex justify-between text-[10px] sm:text-xs text-neutral-500 mt-3">
              <span>2021</span>
              <span>2022</span>
              <span>2023</span>
              <span>2024</span>
              <span>2025</span>
            </div>

            <div className="mt-5 sm:mt-6">
              <motion.h3
                initial={{ y: 10, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35 }}
                className="text-3xl sm:text-4xl md:text-5xl font-semibold"
              >
                50+
              </motion.h3>
              <p className="text-xs sm:text-sm text-neutral-400 mt-2">
                Successful expeditions completed worldwide.
              </p>
            </div>
          </motion.div>

          {/* MIDDLE: 3x Faster with animated rings */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ scale: 0.99 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
            className="relative rounded-xl border border-[#1E2731] bg-[#162230]/80 overflow-hidden p-6 sm:p-8 min-h-[180px] sm:min-h-[220px] flex items-center"
          >
            {/* Animated rings top-right */}
            <div className="absolute -top-20 -right-16 sm:-top-24 sm:-right-20 z-0 pointer-events-none">
              {/* OUTER ring */}
              <motion.div
                animate={{ rotate: 360 }}
                transition={{
                  repeat: Infinity,
                  duration: 24,
                  ease: "linear",
                }}
                className="absolute w-[220px] h-[220px] sm:w-[260px] sm:h-[260px] rounded-full border-[2px] border-white opacity-30"
              />

              <motion.div
                animate={{ rotate: 360 }}
                transition={{
                  repeat: Infinity,
                  delay: 2,
                  duration: 14,
                  ease: "linear",
                }}
                className="absolute top-[36px] left-[36px] w-[148px] h-[148px] sm:w-[180px] sm:h-[180px] rounded-full border-[2px] border-[#162230]/80 opacity-15 flex items-center justify-center"
              >
                <motion.svg
                  width={26}
                  height={26}
                  viewBox="0 0 24 24"
                  fill="white"
                  animate={{
                    scale: [1, 1.08, 1],
                    opacity: [0.85, 1, 0.85],
                  }}
                  transition={{
                    repeat: Infinity,
                    duration: 1.8,
                    ease: "easeInOut",
                  }}
                  className="drop-shadow-[0_0_12px_rgba(255,255,255,0.45)]"
                >
                  <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
                </motion.svg>
              </motion.div>
            </div>

            {/* Text */}
            <div className="relative z-10">
                <h3 className="relative text-[55px] font-semibold z-10 mt-auto">
                    3x
                </h3>
                <p className="relative text-neutral-400 text-sm mt-2 z-10">
                    Faster than traditional expedition planning and coordination.
                </p>
            </div>
          </motion.div>

          {/* RIGHT: Rating + Hero image */}
          <motion.div
            whileHover={{ scale: 0.985 }}
            transition={{ duration: 0.35 }}
            className="md:row-span-2 relative rounded-xl 0 overflow-hidden bg-[#0c0f12] min-h-[220px] sm:min-h-[260px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${bgImage})` }}
            />
            <div className="absolute inset-0 bg-black/30" />

            <div className="absolute top-5 sm:top-6 left-5 sm:left-6 flex items-center gap-1">
              <h2 className="text-base sm:text-lg font-semibold tracking-tight">
                BroadBoyAdventures
              </h2>
              <span className="text-[9px] sm:text-[10px] font-medium align-top">
                ®
              </span>
            </div>

            <div className="absolute top-5 sm:top-6 right-5 sm:right-6 text-right leading-tight">
              <p className="text-lg sm:text-xl font-semibold">
                4.9{" "}
                <span className="text-neutral-400 text-xs sm:text-sm">/ 5</span>
              </p>

              <div className="flex justify-end gap-[2px] mt-1 text-white text-xs sm:text-sm">
                {Array.from({ length: 5 }).map((_, i) => (
                  <svg
                    key={i}
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z" />
                  </svg>
                ))}
              </div>
            </div>

            <div className="absolute bottom-5 sm:bottom-6 left-5 sm:left-6 max-w-[70%]">
              <h3 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight">
                32+
              </h3>
              <p className="text-xs sm:text-sm text-neutral-300 mt-1 leading-snug">
                Happy climbers and counting from first-timers to elite
                mountaineers.
              </p>
            </div>
          </motion.div>

          {/* BOTTOM: Expedition reach card */}
        <motion.div
            whileHover={{ scale: 0.985 }}
            className="relative bg-[#162230]/80 border border-[#162230]/80 rounded-lg p-6 overflow-hidden flex flex-col"
          >
            <motion.svg
  viewBox="0 0 730 730"
  className="absolute -top-10 -right-10 opacity-[0.08]"
  initial={{ rotate: 0 }}
  animate={{ rotate: 360 }}
  transition={{ duration: 18, ease: "linear", repeat: Infinity }}
>
  <g transform="translate(5.753 6)">
    <path
      d="M 359 0 C 557.27 0 718 160.73 718 359 C 718 557.27 557.27 718 359 718 C 160.73 718 0 557.27 0 359 C 0 160.73 160.73 0 359 0 Z"
      fill="transparent"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2255.981201171875 2255.981201171875"
      strokeDashoffset="-952621.9019128418"
    />
    <path
      d="M 359 0 C 557.27 0 718 160.73 718 359 C 718 557.27 557.27 718 359 718 C 160.73 718 0 557.27 0 359 C 0 160.73 160.73 0 359 0 Z"
      fill="transparent"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2255.981201171875 2255.981201171875"
      strokeDashoffset="-952847.5000329589"
      transform="rotate(990 359 359)"
    />
    <path
      d="M 270.479 0 C 419.861 0 540.959 160.73 540.959 359 C 540.959 557.27 419.861 718 270.479 718 C 121.098 718 0 557.27 0 359 C 0 160.73 121.098 0 270.479 0 Z"
      fill="transparent"
      transform="translate(89 0)"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1987.638671875 1987.638671875"
      strokeDashoffset="-839707.7715136718"
    />
    <path
      d="M 270.479 0 C 419.861 0 540.959 160.73 540.959 359 C 540.959 557.27 419.861 718 270.479 718 C 121.098 718 0 557.27 0 359 C 0 160.73 121.098 0 270.479 0 Z"
      fill="transparent"
      transform="translate(89 0) rotate(990 270.479 359)"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1987.638671875 1987.638671875"
      strokeDashoffset="-839906.5353808594"
    />
    <path
      d="M 187.86 0 C 291.613 0 375.721 160.73 375.721 359 C 375.721 557.27 291.613 718 187.86 718 C 84.108 718 0 557.27 0 359 C 0 160.73 84.108 0 187.86 0 Z"
      fill="transparent"
      transform="translate(171.5 0)"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1760.593505859375 1760.593505859375"
      strokeDashoffset="-744141.2541540527"
    />
    <path
      d="M 187.86 0 C 291.613 0 375.721 160.73 375.721 359 C 375.721 557.27 291.613 718 187.86 718 C 84.108 718 0 557.27 0 359 C 0 160.73 84.108 0 187.86 0 Z"
      fill="transparent"
      transform="translate(171.5 0) rotate(990 187.86 359)"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1760.593505859375 1760.593505859375"
      strokeDashoffset="-744317.3135046386"
    />
    <path
      d="M 89.504 0 C 138.936 0 179.008 160.73 179.008 359 C 179.008 557.27 138.936 718 89.504 718 C 40.072 718 0 557.27 0 359 C 0 160.73 40.072 0 89.504 0 Z"
      fill="transparent"
      transform="translate(269.5 0)"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1539.562255859375 1539.562255859375"
      strokeDashoffset="-651026.9933239745"
    />
    <path
      d="M 89.504 0 C 138.936 0 179.008 160.73 179.008 359 C 179.008 557.27 138.936 718 89.504 718 C 40.072 718 0 557.27 0 359 C 0 160.73 40.072 0 89.504 0 Z"
      fill="transparent"
      transform="translate(269.5 0) rotate(990 89.504 359)"
      stroke="white"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1539.562255859375 1539.562255859375"
      strokeDashoffset="-651180.9495495606"
    />
  </g>
            </motion.svg>

            <h3 className="relative text-[55px] font-semibold z-10 mt-auto">
              23+
            </h3>
            <p className="relative text-neutral-400 text-sm mt-2 z-10">
              Expedition & trekking projects across Nepal, China & Pakistan.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
